import { createSlice } from '@reduxjs/toolkit';
import {
    fetchBestSellerProductsList,
    fetchProductList,
    removeVisibility,
    updateBestSellerPosition,
} from '../thunk/productThunk';

const initialState = {
    data: {},
    loading: false,
    error: null,
    ProductList: {},
    bestSellerProducts: [],
    bestSellerProductsLoading: false,
    bestSellerProductsError: null,
    deliveryPartnerProducts: [],
    deliveryPartnerProductsLoading: false,
    deliveryPartnerProductsError: null,
    removeVisibilityLoading: false,
    removeVisibilityError: null,
    updatePositionLoading: false,
    updatePositionError: null,
};
const productSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        updateCartFieldsInProducts: (state, action) => {
            const cart = action.payload || {};

            // Iterate through each product in ProductList
            for (const [sku, product] of Object.entries(state.ProductList)) {
                if (cart[sku]) {
                    // Update the product with cart information if it exists in cart
                    product.cart_qty = cart[sku].qty || 0;
                    product.cart_preference = cart[sku]?.preference || null;
                    product.cart_product_notes = cart[sku].preference?.custom_note || null;
                } else {
                    // Reset cart fields if product is not in cart
                    product.cart_qty = 0;
                    product.cart_preference = null;
                    product.cart_product_notes = null;
                }
            }
        },
        reorderBestSellerProducts: (state, action) => {
            const { oldIndex, newIndex } = action.payload;
            const result = Array.from(state.bestSellerProducts);
            const [removed] = result.splice(oldIndex, 1);
            result.splice(newIndex, 0, removed);
            state.bestSellerProducts = result;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductList.fulfilled, (state, action) => {
                state.loading = false;
                // console.log("Original ProductList API Response:", action.payload.data);
                const rawProductData = action.payload.data;
                const augmentedProducts = {};
                for (const skuCode in rawProductData) {
                    if (Object.hasOwnProperty.call(rawProductData, skuCode)) {
                        const product = rawProductData[skuCode];
                        augmentedProducts[skuCode] = {
                            ...product,
                            cart_qty: 0,
                            cart_preference: null,
                            cart_product_notes: null,
                        };
                    }
                }
                state.ProductList = augmentedProducts;
                // console.log("Augmented ProductList for State:", state.ProductList);
            })
            .addCase(fetchProductList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            //
            .addCase(fetchBestSellerProductsList.pending, (state) => {
                state.bestSellerProductsLoading = true;
                state.bestSellerProductsError = null;
            })
            .addCase(fetchBestSellerProductsList.fulfilled, (state, action) => {
                state.bestSellerProductsLoading = false;
                state.bestSellerProducts = action.payload.data;
            })
            .addCase(fetchBestSellerProductsList.rejected, (state, action) => {
                state.bestSellerProductsLoading = false;
                state.bestSellerProductsError = action.payload;
            })
            //  Remove a Visibility Info (Admin Product Details Page)
             .addCase(removeVisibility.pending, (state) => {
                state.removeVisibilityLoading = true;
                state.removeVisibilityError = null;
            })
            .addCase(removeVisibility.fulfilled, (state, action) => {
                state.removeVisibilityLoading = false;
                state.deliveryPartnerProducts = action.payload.data;
            })
            .addCase(removeVisibility.rejected, (state, action) => {
                state.removeVisibilityLoading = false;
                state.removeVisibilityError = action.payload;
            })
             // Update Best Seller Position
            .addCase(updateBestSellerPosition.pending, (state) => {
                state.updatePositionLoading = true;
                state.updatePositionError = null;
            })
            .addCase(updateBestSellerPosition.fulfilled, (state, action) => {
                state.updatePositionLoading = false;
                // Position already updated via local reorder
            })
            .addCase(updateBestSellerPosition.rejected, (state, action) => {
                state.updatePositionLoading = false;
                state.updatePositionError = action.payload;
                // Optionally revert the reorder on error
            });
    },
});
export const { reorderBestSellerProducts } = productSlice.actions;

export default productSlice.reducer;
export const { updateCartFieldsInProducts } = productSlice.actions;
// Selectors
export const selectProducts = (state) => state.products.data;
export const selectLoadingLoading = (state) => state.products.loading;
export const selectProductError = (state) => state.products.error;
export const selectDeliveryPartnerProducts = (state) => state.products.deliveryPartnerProducts;
